module.exports = __webpack_public_path__ + "static/media/growth-lab-dark.38475fdd.png";